import React from "react";

type PaymentHeaderProps = {
  title: string;
  stepNumber?: number;
  isComplete?: boolean;
  subTitle?: string;
  price?: string;
  onEdit?: () => void;
  dropdownUp?: boolean;
  onDropdownClick?: () => void;
};

const PaymentHeader = ({
  title,
  stepNumber,
  isComplete,
  subTitle,
  price,
  onEdit,
  dropdownUp = false,
  onDropdownClick,
}: PaymentHeaderProps) => {
  return (
    <div
      className={`flex items-center justify-between ${
        (!!dropdownUp || !!stepNumber) && "mb-4"
      } ${(stepNumber ?? 0) > 1 && "mt-6"}`}
    >
      {/* Left Section with Checkmark and Labels */}
      <div className="flex items-center gap-3 min-w-0">
        {!!isComplete && !!stepNumber && (
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 shadow-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5 text-gray-500"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
        )}
        {!isComplete && !!stepNumber && (
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-navy text-cream text-lg font-medium">
            {stepNumber}
          </div>
        )}
        <h2 className="text-xl font-bold whitespace-nowrap">{title}</h2>
        {/* Deliberately NOT `capitalize`: this carries the buyer's email once
            the Contact step is collapsed, and title-casing an address misprints
            the one value they're being asked to check. `truncate` (with the
            min-w-0 above) keeps a long address from pushing Edit off the row,
            and translate="no" keeps a page translation off it. */}
        {subTitle && (
          <h3 className="text-sm font-sm truncate" translate="no">
            {subTitle}
          </h3>
        )}
      </div>

      {/* Right Section with Edit/Dropdown Button + Price */}
      <div className="flex items-center gap-3">
        {!dropdownUp && price && (
          <h3 className="text-sm font-sm capitalize whitespace-nowrap">
            ${price}
          </h3>
        )}
        <button
          type="button"
          className="text-sm text-gray-500 hover:underline"
          onClick={onEdit}
          hidden={!onEdit}
        >
          Edit
        </button>
        <button
          type="button"
          onClick={onDropdownClick}
          hidden={!onDropdownClick}
        >
          <span>{dropdownUp ? "▲" : "▼"}</span>
        </button>
      </div>
    </div>
  );
};

export default PaymentHeader;
